module.exports = __webpack_public_path__ + "img/c9.3b818418.png";